import { createSlice, createSelector } from "@reduxjs/toolkit";
const BRAND_SETTINGS_FEATURE_KEY = "brandSettings";
const initialBrandSettingsState = {
  registrationSettings: {
    storeRegistrationCustomerData: false
  },
  snackbarNotificationTimesSetup: null,
  brandName: null,
  newCashierFlow: true,
  hiddenSiteMenuLinks: [],
  newSiteMenuLinks: [],
  promotionTermsOpenByDefault: false,
  promotionalOffersSelected: false,
  responsibleGamblingTools: {
    limits: false,
    limitSettings: {
      session: {
        showRemaining: false,
        amountType: "minutes"
      }
    },
    selfExclusion: false,
    fixedSelfExclusion: false,
    coolingOff: false,
    accountDeactivation: {
      active: false,
      showSelfDeleteInMyAccount: false
    }
  },
  additionalCryptoMethods: null,
  registrationRestrictedWarningCountries: [],
  enableSelfExclusionTerms: false,
  disableTransactionHistoryDateRange: false,
  hideLiveCasinoWelcomeBanner: false,
  showCashierAfterRegistration: true,
  skipLimitSetupButtonEnabled: false,
  successfulRegistrationPopup: {
    enabled: false,
    showLimitsButton: false
  },
  verificationRedirectAfterOndato: true,
  refProgramEnabled: false,
  showCustomerSession: false,
  showWatchersChat: {
    enabled: false,
    unAuthorized: false
  },
  finalizeLimitsSetup: null,
  stayOnPageAfterRegistration: {
    enabled: false,
    exceptPages: []
  },
  cashierPendingWithdrawals: {
    enabled: false,
    enableCancelSnackbar: false
  }
};
const brandSettingsSlice = createSlice({
  name: BRAND_SETTINGS_FEATURE_KEY,
  initialState: initialBrandSettingsState,
  reducers: {
    enableRegistrationSuccessNotification: () => {
    },
    enableReferralProgram: (state) => {
      state.refProgramEnabled = true;
    }
  }
});
const brandSettingsReducer = brandSettingsSlice.reducer;
const {
  enableRegistrationSuccessNotification,
  enableReferralProgram
} = brandSettingsSlice.actions;
const getBrandSettingsState = (rootState) => rootState[BRAND_SETTINGS_FEATURE_KEY];
const selectBrandSettingsRegistrationCustomerSaver = createSelector(
  getBrandSettingsState,
  (s) => s.registrationSettings.storeRegistrationCustomerData
);
const selectSnackbarNotificationSetup = createSelector(
  getBrandSettingsState,
  (s) => s.snackbarNotificationTimesSetup
);
const selectOfficialBrandName = createSelector(
  getBrandSettingsState,
  (s) => s.brandName
);
const selectHiddenMenuLinks = createSelector(
  getBrandSettingsState,
  (s) => s.hiddenSiteMenuLinks
);
const selectNewSiteMenuLinks = createSelector(
  getBrandSettingsState,
  (s) => s.newSiteMenuLinks
);
const selectNewCashierFlow = createSelector(
  getBrandSettingsState,
  (s) => s.newCashierFlow
);
const selectPromotionTermsOpenDefault = createSelector(
  getBrandSettingsState,
  (s) => s.promotionTermsOpenByDefault
);
const selectPromotionalOffersSelected = createSelector(
  getBrandSettingsState,
  (s) => s.promotionalOffersSelected
);
const selectResponsibleGamblingTools = createSelector(
  getBrandSettingsState,
  (s) => s.responsibleGamblingTools
);
const selectRegRestrictedWarningCountries = createSelector(
  getBrandSettingsState,
  (s) => s.registrationRestrictedWarningCountries
);
const selectIsLiveCasinoWelcomeBannerHidden = createSelector(
  getBrandSettingsState,
  (s) => s.hideLiveCasinoWelcomeBanner
);
const selectCashierAdditionalCryptoMethods = createSelector(
  getBrandSettingsState,
  ({ additionalCryptoMethods }) => {
    const { enabled, methods } = additionalCryptoMethods || {};
    const getCryptoMethds = methods && !!Object.values(methods).length ? methods : [];
    return enabled && getCryptoMethds;
  }
);
const getSelfExclusionTermsStatus = createSelector(
  getBrandSettingsState,
  (s) => s.enableSelfExclusionTerms
);
const transactionHistoryDateRangeDisabled = createSelector(
  getBrandSettingsState,
  (s) => s.disableTransactionHistoryDateRange
);
const showCashierAfterRegStatus = createSelector(
  getBrandSettingsState,
  (s) => s.showCashierAfterRegistration
);
const showSkipLimitSetupButton = createSelector(
  getBrandSettingsState,
  (s) => s.skipLimitSetupButtonEnabled
);
const showRegisterFinalAfterRegStatus = createSelector(
  getBrandSettingsState,
  (s) => s.successfulRegistrationPopup.enabled
);
const selectLimitsInfoInRegistrationPopup = createSelector(
  getBrandSettingsState,
  (s) => s.successfulRegistrationPopup.showLimitsButton
);
const selectRegisterFinalAfterRegBanners = createSelector(
  getBrandSettingsState,
  (s) => s.successfulRegistrationPopup.bannerImages
);
const selectVerificationRedirectAfterOndato = createSelector(
  getBrandSettingsState,
  ({ verificationRedirectAfterOndato }) => verificationRedirectAfterOndato
);
const selectIsReferralProgramEnabled = createSelector(
  getBrandSettingsState,
  ({ refProgramEnabled }) => refProgramEnabled
);
const selectCustomerSessionVisibilityStatus = createSelector(
  getBrandSettingsState,
  ({ showCustomerSession }) => showCustomerSession
);
const selectWatchersChatConfig = createSelector(
  getBrandSettingsState,
  ({ showWatchersChat }) => showWatchersChat || {}
);
const selectFinalizeLimitsSetup = createSelector(
  getBrandSettingsState,
  ({ finalizeLimitsSetup }) => finalizeLimitsSetup || {}
);
const selectStayOnPageAfterRegConfig = createSelector(
  getBrandSettingsState,
  ({ stayOnPageAfterRegistration }) => stayOnPageAfterRegistration
);
const getCashierPendingWithdrawalsConfig = createSelector(
  getBrandSettingsState,
  ({ cashierPendingWithdrawals }) => cashierPendingWithdrawals
);
export {
  BRAND_SETTINGS_FEATURE_KEY,
  brandSettingsReducer,
  brandSettingsSlice,
  enableReferralProgram,
  enableRegistrationSuccessNotification,
  getBrandSettingsState,
  getCashierPendingWithdrawalsConfig,
  getSelfExclusionTermsStatus,
  initialBrandSettingsState,
  selectBrandSettingsRegistrationCustomerSaver,
  selectCashierAdditionalCryptoMethods,
  selectCustomerSessionVisibilityStatus,
  selectFinalizeLimitsSetup,
  selectHiddenMenuLinks,
  selectIsLiveCasinoWelcomeBannerHidden,
  selectIsReferralProgramEnabled,
  selectLimitsInfoInRegistrationPopup,
  selectNewCashierFlow,
  selectNewSiteMenuLinks,
  selectOfficialBrandName,
  selectPromotionTermsOpenDefault,
  selectPromotionalOffersSelected,
  selectRegRestrictedWarningCountries,
  selectRegisterFinalAfterRegBanners,
  selectResponsibleGamblingTools,
  selectSnackbarNotificationSetup,
  selectStayOnPageAfterRegConfig,
  selectVerificationRedirectAfterOndato,
  selectWatchersChatConfig,
  showCashierAfterRegStatus,
  showRegisterFinalAfterRegStatus,
  showSkipLimitSetupButton,
  transactionHistoryDateRangeDisabled
};
